module.exports = __webpack_public_path__ + "static/media/spotify.964ebfa8.svg";